type ColumnsLocale = typeof import('../en/columns').default

const columns = {
	course: {
		id: 'ID',
		title: 'Título',
		slug: 'URL',
		description: 'Descripción',
		shortDescription: 'Descripción corta',
		coverImage: 'Imagen de portada',
		language: 'Idioma',
		isPublished: 'Publicado',
		isCollection: 'Colección',
		accessLevel: 'Nivel de acceso',
		collectionType: 'Tipo de programa',
		featuredRank: 'Orden de destacado',
		isTemplate: 'Plantilla',
		owner: 'Propietario',
		ownerEmail: 'Email del propietario',
		category: 'Categoría',
		moduleCount: 'Módulos',
		topicCount: 'Temas',
		resourceCount: 'Recursos',
		enrollmentCount: 'Inscripciones',
		instanceCount: 'Instancias',
		stats: 'Estadísticas',
		actions: 'Acciones',
	},
	topic: {
		id: 'ID',
		title: 'Título',
		name: 'Nombre',
		slug: 'URL',
		description: 'Descripción',
		position: 'Posición',
		module: 'Módulo',
		course: '{{mainEntityLabel}}',
		linkedIn: 'Enlazado en {{mainEntityLabelPluralLower}}',
		resourceCount: 'Recursos',
		progressCount: 'Progreso',
		actions: 'Acciones',
	},
	user: {
		id: 'ID',
		email: 'Email',
		username: 'Nombre de usuario',
		name: 'Nombre',
		accountStatus: 'Estado de cuenta',
		subscriptionStatus: 'Suscripción',
		accountStatusUpdatedAt: 'Estado actualizado',
		accountStatusUpdatedBy: 'Actualizado por',
		accountStatusReason: 'Motivo del estado',
		courseEnrollmentCount: 'Inscripciones en cursos',
		collectionEnrollmentCount:
			'Inscripciones en {{collectionEntityLabelPluralLower}}',
		ownedCourseCount: 'Cursos propios',
		polarCustomerId: 'ID de cliente Polar',
		roles: 'Roles',
		roleCount: 'Número de roles',
		actions: 'Acciones',
	},
	role: {
		id: 'ID',
		name: 'Nombre',
		description: 'Descripción',
		userCount: 'Número de usuarios',
		actions: 'Acciones',
	},
	module: {
		id: 'ID',
		title: 'Título',
		description: 'Descripción',
		position: 'Posición',
		course: '{{mainEntityLabel}}',
		topicCount: 'Temas',
		isPublished: 'Publicado',
	},
	resource: {
		id: 'ID',
		title: 'Título',
		type: 'Tipo',
		url: 'URL',
		description: 'Descripción',
		topic: 'Tema',
		isCommented: 'Comentado',
	},
	enrollment: {
		id: 'ID',
		user: 'Usuario',
		course: '{{mainEntityLabel}}',
		status: 'Estado',
		progress: 'Progreso',
		createdAt: 'Inscrito',
		updatedAt: 'Actualizado',
	},
	category: {
		id: 'ID',
		name: 'Nombre',
		slug: 'Slug',
		description: 'Descripción',
		parentId: 'ID del padre',
		instructorPersonaId: 'Persona docente',
		instructorPersonaRationale: 'Razonamiento docente',
		editorialDomain: 'Dominio editorial',
		editorialReaderIntent: 'Intención del lector',
		editorialWritingGuidelines: 'Guías de escritura',
		editorialAvoid: 'Evitar',
		courseCount: '{{mainEntityLabelPlural}}',
		parentName: 'Padre',
		actions: 'Acciones',
		childrenCount: 'Hijos',
	},
} satisfies ColumnsLocale

export default columns
